import styled from '@emotion/styled'
import ms from 'ms'
import React, {Component} from 'react'
import {PALETTE} from '../styles/paletteV3'
import relativeDate from '../utils/date/relativeDate'

const StyledSpan = styled('span')({
  color: PALETTE.SLATE_600,
  fontSize: 11,
  lineHeight: '16px'
})









class TimelineEventDate extends Component {constructor(...args) { super(...args); TimelineEventDate.prototype.__init.call(this); }
  __init() {this.state = {
    fromNow: relativeDate(this.props.createdAt)
  }}
  

  componentDidMount() {
    this.intervalId = window.setInterval(() => {
      const fromNow = relativeDate(this.props.createdAt)
      if (fromNow !== this.state.fromNow) {
        this.setState({
          fromNow
        })
      }
    }, ms('1m'))
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  render() {
    const {fromNow} = this.state
    return React.createElement(StyledSpan, null, fromNow)
  }
}

export default TimelineEventDate
